<template>
  <div class="main">
    <h2 class="title">您正在身份证号码找回密码</h2>
    <el-input class="input" placeholder="请输入身份证信息" v-model="idCard"></el-input>
    <el-row>
      <el-button class="but but1" @click="registerByPass">提交验证身份</el-button>
    </el-row>
    <img class="hf_logo2" src="@/assets/images/hf_logo2.png" alt=""/>
  </div>
</template>

<script>
export default {
  data(){
    return{
      idCard:''
    }
  },
  methods:{
    registerByPass(){
      this.$message({
        message: '暂不支持司机登录',
        type: 'warning'
      });
    }
  }
}
</script>

<style scoped>
  .main{
    width: 1052px;
    margin: 0 auto;
    padding-top: 60px;
    text-align: center;
  }
  .title{
    font-size: 24px;
    font-weight: normal;
    padding-bottom: 46px;
  }
  .input{
    width: 300px;
    /*padding-left: 10px;*/
    font-size: 16px;
    height: 38px;
    /*border: 1px solid #cccccc;*/
    border-radius: 2px;
    margin-bottom: 16px;
  }
  .but{
    margin: 0 auto;
    display: block;
    width: 300px;
    height: 42px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    border: none;
  }
  .but1{
    background: #b40910;
    margin-bottom: 16px;
  }
  .hf_logo2{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 800px;
    height: 600px;
  }
</style>
